<template>
  <div id="CustomRolesAdmin">
    <main>
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container-fluid">
          <div class="page-header-content">
            <h1 class="page-header-title">
              <div class="page-header-icon">
                <i data-feather="activity"></i>
              </div>
              <span>Custom Roles</span>
            </h1>
            <!-- <div class="page-header-subtitle" v-if="role != 'all'">{{role}}</div> -->
          </div>
        </div>
      </div>
      <div class="container-fluid mt-n10">
        <div class="row">
          <div class="col-md-12">
            <div class="card mb-4">
              <!-- <div class="card-header">DataTable Example</div> -->
              <div class="card-body">
                <vue-good-table
                  :columns="columns"
                  :rows="customRoles"
                  :search-options="{
                    enabled: true,
                    trigger: 'enter',
                  }"
                  :pagination-options="{
                    enabled: true,
                    perPage: 20,
                  }"
                  styleClass="vgt-table condensed myGoodTable"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'name'">
                      <router-link :to="{name: 'CustomRoleDetailsAdmin', params:{uuid: props.row.uuid}}">{{props.row.name}}</router-link>
                    </span>
                    <span v-if="props.column.field == 'description'">{{props.row.description}}</span>
                    <span v-if="props.column.field == 'edit'">
                      <router-link :to="{name: 'EditCustomRoleAdmin', params: {uuid: props.row.uuid} }" class="btn btn-xs btn-outline-secondary" title="Update">edit</router-link>
                    </span>
                    <span v-if="props.column.field == 'delete'">
                      <button @click="deleteCustomRole(props.row.uuid, props.row.originalIndex)" class="btn btn-xs btn-outline-secondary" title="Delete">delete</button>
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>


<script>
import axios from "axios";
//import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "CustomRolesAdmin",

  data() {
    return {
      customRoles: [],
      name: "",
      description: "",
    };
  },

  mounted() {
    let loading = this.$loading.show();
    axios.get("/admin/custom-roles").then((res) => {
      if (res.data.status == "success") {
        this.customRoles = res.data.customRoles;
      }
      loading.hide();
    });
  },

  methods: {
    deleteCustomRole(uuid, index) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "DELETE: " + this.customRoles[index].name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.value) {
            /* actural action */
            let loading = this.$loading.show();

            axios.post(`/admin/custom-role/delete/${uuid}`).then((res) => {
              if (res.data.status == "success") {
                this.$swal.fire("Deleted!", `${this.customRoles[index].name} deleted`, "success");
                this.customRoles.splice(index, 1);
              } else {
                this.$swal("", res.data.message, "error");
              }
              loading.hide();
            });
            /* end of actural action */
          }
        });
    },
  },

  computed: {
    columns() {
      let cols = [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Description",
          field: "description",
        },
        {
          label: "",
          field: "edit",
        },
        {
          label: "",
          field: "delete",
        },
      ];
      return cols;
    },

    client() {
      return this.$store.state.client;
    },
  },
};
</script>

